import { useQuery } from '@tanstack/react-query'

import { EngagementV1, EngagementV2 } from '@sparkai/shared-types'

import { apiClient } from '../apiClient'

export const QUERY_KEY = 'engagement-v3'

type QueryRetry = boolean | number | ((failureCount: number, error: unknown) => boolean)

export function useGetByIdV3(id?: string, options?: { retry?: QueryRetry }) {
  return useQuery<EngagementV1 | EngagementV2, Error>({
    queryKey: [QUERY_KEY, id],
    queryFn: async () => {
      const { data } = await apiClient.get<EngagementV1 | EngagementV2>(`/int/v3/engagements/${id}`)
      return data
    },
    enabled: Boolean(id),
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: options?.retry,
  })
}
